module.exports = __webpack_public_path__ + "img/ts16.c60c410f.png";